import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "toast-container",
  "aria-live": "polite"
}
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toasts, (toast) => {
      return (_openBlock(), _createElementBlock("div", {
        key: toast.id,
        class: _normalizeClass(["toast", `toast-${toast.type}`]),
        role: "alert"
      }, [
        _createElementVNode("span", null, _toDisplayString(toast.message), 1),
        _createElementVNode("button", {
          type: "button",
          class: "toast-close",
          "aria-label": "Dismiss",
          onClick: ($event: any) => (_ctx.remove(toast.id))
        }, "×", 8, _hoisted_2)
      ], 2))
    }), 128))
  ]))
}